import React from "react";
import IconArrowDownYellow from "../../../../assets/icons/CaretDownYellow.svg";
import iconArrowDownWhite from "../../../../assets/icons/CaretDownWhite.svg";
import iconArrowDownBlue from "../../../../assets/icons/CaretDownBlueDark.svg";
import classNames from "classnames";

const ObjetivesChoicesBubbleContent = ({
  register,
  objectiveOption,
  handleSelectObjectiveOption,
  handleCleanObjectiveField,
  handleStartIteraction,
  selectedClassProfile,
  objectiveGroupOpen,
  onObjectGroupOpen,
  objectiveGroupToDisplay,
  handleSelectObjectivesGroup,
  isSelected,
  setObjectiveGroupToDisplay,
  onShowLocalBubble1,
  localValidateGoals,
}) => {
  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col gap-4">
        <div>¡Perfecto!</div>
        <div>
          Ahora enfoquémonos en lo que deseas lograr en esta sesión para guiar
          adecuadamente la planeación. ¿Ya tienes definidos los objetivos de
          aprendizaje?
        </div>
        <div className="flex flex-col gap-4">
          <div className="flex gap-4 flex-col">
            <div className="flex flex-col">
              <div
                className={classNames(
                  "flex justify-between bg-shaiaBlue text-DarkBlue-500 py-2 px-4 cursor-pointer",
                  {
                    "rounded-t-md": objectiveOption === 1,
                    "rounded-md": !objectiveOption,
                  }
                )}
                onClick={() => handleSelectObjectiveOption(1)}
              >
                <div className="font-bold">Sí, ayúdame a revisarlo(s)</div>
                <div>
                  <img
                    className={classNames(
                      "transition-transform transform rotate-0 ",
                      {
                        "rotate-180": objectiveOption === 1,
                      }
                    )}
                    src={iconArrowDownBlue}
                    alt=""
                  />
                </div>
              </div>
              {objectiveOption === 1 && (
                <div className="border-2 border-shaiaBlue rounded-b-md">
                  <div className="bg-transparent bg-opacity-10">
                    <textarea
                      className="bg-transparent w-full p-4 focus:outline-none"
                      placeholder="Escribe aquí el o los objetivos de aprendizaje que has definido para esta sesión."
                      {...register("objective_option1", {
                        required: "Este campo es requerido",
                      })}
                    />
                  </div>
                  <div className="flex justify-end gap-4 p-4">
                    <button
                      type="button"
                      onClick={() => handleCleanObjectiveField(1)}
                      className="text-shaiaBlue"
                    >
                      Limpiar
                    </button>
                    <button
                      onClick={() => handleStartIteraction(1)}
                      type="button"
                      className="text-shaiaBlue"
                    >
                      Guardar
                    </button>
                  </div>
                </div>
              )}
            </div>
            <div className="flex flex-col">
              <div
                className={classNames(
                  "flex justify-between bg-Yellow-500 text-DarkBlue-500  py-2 px-4 cursor-pointer",
                  {
                    "rounded-t-md": objectiveOption === 2,
                    "rounded-md": !objectiveOption,
                  }
                )}
                onClick={() => handleSelectObjectiveOption(2)}
              >
                <div className="font-bold">
                  No, trabajemos para definirlo(s)
                </div>
                <div>
                  <img
                    className={classNames(
                      "transition-transform transform rotate-0 ",
                      {
                        "rotate-180": objectiveOption === 2,
                      }
                    )}
                    src={iconArrowDownBlue}
                    alt=""
                  />
                </div>
              </div>
              {objectiveOption === 2 && (
                <div className="border-2 border-Yellow-500 rounded-b-md">
                  <div className="bg-transparent bg-opacity-10">
                    <textarea
                      className="bg-transparent w-full p-4 focus:outline-none"
                      placeholder="Escribe aquí las habilidades o conocimientos que deseas que tus estudiantes trabajen en esta sesión"
                      {...register("objective_option2", {
                        required: "Este campo es requerido",
                      })}
                    />
                  </div>
                  <div className="flex justify-end gap-4 p-4">
                    <button
                      type="button"
                      onClick={() => handleCleanObjectiveField(2)}
                      className="text-Yellow-500"
                    >
                      Limpiar
                    </button>
                    <button
                      type="button"
                      onClick={() => handleStartIteraction(2)}
                      className="text-Yellow-500"
                    >
                      Guardar
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        {selectedClassProfile?.objectives?.length && (
          <div className="flex flex-col gap-4">
            <div>
              Tu grupo ya posee objetivos de aprendizaje previamente revisados.
              Si lo prefieres, puedes seleccionar alguno(s) de ellos.
            </div>
            <div>
              <div
                className={classNames(
                  "flex justify-around bg-DarkBlue-500 p-4 rounded-md cursor-pointer",
                  {
                    "rounded-b-0": !objectiveGroupOpen,
                  }
                )}
                onClick={() => onObjectGroupOpen()}
              >
                <div className="w-full text-left">Objetivos de tu grupo</div>
                <div>
                  <img
                    className={classNames(
                      "transition-transform transform rotate-0 ",
                      {
                        "rotate-180": objectiveGroupOpen,
                      }
                    )}
                    src={iconArrowDownWhite}
                    alt=""
                  />
                </div>
              </div>
              {objectiveGroupOpen && (
                <div
                  className={classNames(
                    "flex flex-col gap-4 rounded-b-md bg-DarkBlue-500 bg-opacity-25",
                    {
                      "h-60 overflow-y-auto":
                        selectedClassProfile?.objectives?.length > 3,
                    }
                  )}
                >
                  {selectedClassProfile.objectives.map((e) => (
                    <div className="flex flex-col gap-4 p-1">
                      <div className="p-2">
                        {e.id === objectiveGroupToDisplay
                          ? e.description
                          : `${e.description.substring(0, 100)}...`}
                      </div>
                      <div className="flex gap-3 justify-end">
                        <div
                          onClick={() => handleSelectObjectivesGroup(e)}
                          className={classNames(
                            " font-bold underline flex items-center",
                            {
                              "text-Red-500": isSelected(e),
                              "text-shaiaBlue": !isSelected(e),
                            }
                          )}
                        >
                          {isSelected(e) ? "Deseleccionar" : "Seleccionar"}
                        </div>
                        <div
                          className="flex gap-3 cursor-pointer"
                          onClick={() =>
                            setObjectiveGroupToDisplay(
                              e.id === objectiveGroupToDisplay ? null : e.id
                            )
                          }
                        >
                          <div className="text-Yellow-500 flex items-center">
                            {e.id === objectiveGroupToDisplay
                              ? "Leer menos"
                              : "Leer más"}
                          </div>
                          <div>
                            <img
                              className={classNames(
                                "transition-transform transform rotate-0 ",
                                {
                                  "rotate-180":
                                    objectiveGroupToDisplay === e.id,
                                }
                              )}
                              src={IconArrowDownYellow}
                              alt="Icon arrow down"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                  <div className="w-full p-4">
                    <button
                      onClick={() => onShowLocalBubble1()}
                      disabled={!localValidateGoals.length}
                      className={classNames(
                        "border-white border-2 w-full text-white p-4 rounded-md mt-4 cursor-pointer",
                        {
                          "text-opacity-30 border-opacity-30 cursor-not-allowed":
                            !localValidateGoals.length,
                        }
                      )}
                    >
                      Guardar
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ObjetivesChoicesBubbleContent;
